angular.module('NumbersEditor')
    .factory('NewGameFactory', [
        '$http', function($http) {

            var urlBase = '/api/Game';
            var gameFactory = {};

            gameFactory.checkGameByDate = function (date) {
                return $http.post(urlBase + '/checkGame', date);
            };

            gameFactory.insertGame = function(game) {
                return $http.post(urlBase, game);
            };

            gameFactory.newGame = function(sportCode, startDate) {
                var newGameDto = { SportCode: sportCode, StartDate: startDate };
                return $http.post(urlBase + '/newGame', newGameDto);
            };

            gameFactory.AddEvent = function(eventLen) {
                var event = {
                    Id: 0,
                    EventNumber: eventLen + 1,
                    EventTime: null,
                    Status: "I",
                    IsDefault: false
                }

                return event;
            };

            return gameFactory;
        }
    ]);